$(document).ready(function () {
  $("body").on("click", ".buy-now", function () {
    var gokwikMid = $(this).attr("data-mid");
    var url = $(".buyNowUrl").val();
    var pId = $(".detail-section.product").length
      ? $(".detail-section.product").attr("data-pid")
      : ($(".detail-panel.product").length
        ? $(".detail-panel.product").attr("data-pid")
        : null);
    var quantity = $(".quantity-select").val();
    $.spinner().start();
    $.ajax({
      url: url,
      type: "post",
      dataType: "json",
      data: {
        pId: pId,
        quantity: quantity,
      },
      success: function (res) {
        const events = ["buy_now", "add_to_cart", "begin_checkout"];
        var dwsid = res.dwsid;
        var basketId = res.tempBasketId;
        var merchantCheckoutId =  dwsid + '||' + basketId;
        events.forEach((event) => {
          const eventCategoryMap = {
            buy_now: "buyNow",
            add_to_cart: "addToCart",
            begin_checkout: "Checkout",
          };
          const eventData = {
            ...res.eventDataForGA,
            event,
            eventCategory: eventCategoryMap[event],
            currentPage: window.location.href,
          };

          if (event === "begin_checkout") {
            eventData.eventAction = "Begin Checkout";
          }

          window.dataLayer.push(eventData);
        });

        $.spinner().stop();
        gokwikSdk.initCheckout({
          environment: "sandbox",
          type: "merchantInfo",
          mid: gokwikMid,
          bannerMesseges: [
            "Sample message one",
            "Sample <b style = 'font-family: metropolisbold'>messages</b> two",
          ],
          merchantParams: {
            merchantCheckoutId: merchantCheckoutId
          },
        });
      },
      error: function (err) {
        $.spinner().stop();
      },
    });

  });

  $("body").on("click", ".gokwik-checkout", function () {
    var gokwikMid = $(this).attr("data-mid");
    var url = $(".removeTempBasketUrl").val();

    $.ajax({
      type: "GET",
      url: url,
      success: function (res) {
        if (res.success) {
          var dwsid = res.dwsid;
          var basketId = res.currentBasketId;
          var merchantCheckoutId = dwsid + '||' + basketId;

          gokwikSdk.initCheckout({
            environment: "sandbox",
            type: "merchantInfo",
            mid: gokwikMid,
            bannerMesseges: [
              "Sample message one",
              "Sample <b style = 'font-family: metropolisbold'>messages</b> two",
            ],
            merchantParams: {
              merchantCheckoutId: merchantCheckoutId
            },
          });
        }
      },
      error: function (err) {
        console.log("Error in Cart-RemoveTempBasket " + JSON.stringify(err));
      },
    });
  });

  window.dataLayer = window.dataLayer || [];

  if (window.gokwikSdk) {
    gokwikSdk.on("checkout-ready", function (response) {
      window.dataLayer.push({
        eventname: "checkoutReady",
      });

      var etmcUrl = $(".etmcUrl").val();

      $.ajax({
        url: etmcUrl,
        type: "POST",
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify({ items: response.items }),
        success: function (res) {
          var result = res;
          _etmc.push(["trackCart", { cart: res.convertedItems }]);
        },
        error: function (err) {
          console.log("Event checkout-ready | Error in Cart-Etmc " + JSON.stringify(err));
        },
      });
    });

    gokwikSdk.on("user-login-initiated", function (response) {
      window.dataLayer.push({
        eventname: "user-login-initiated",
      });
    });

    gokwikSdk.on("user-login-successful", function (response) {
      window.dataLayer.push({
        eventname: "userLoginSuccessful",
      });
    });

    gokwikSdk.on("address-add", function (response) {
      window.dataLayer.push({
        eventname: "address-add",
      });
    });

    gokwikSdk.on("address-selected", function (response) {
      var url = $(".createEventData").val();

      $.ajax({
        type: "GET",
        url: url,
        success: function (res) {
          res.eventDataForGA.currentPage = window.location.href;
          res.eventDataForGA.event = 'add_shipping_info';
          res.eventDataForGA.eventCategory = 'Checkout';
          res.eventDataForGA.eventAction = 'home'
          dataLayer.push(res.eventDataForGA);
        },
        error: function (err) {
          console.log("address-selected | Error in Cart-EventData " + JSON.stringify(err));
        },
      });

      $.ajax({
        type: 'POST',
        url: $('.registerLoginUrl').val(),
        data: {
          firstname: response.first_name,
          lastname: response.last_name,
          phone:response.cart.phone? response.cart.phone : response.recipient_phone,
          email: response.email
        },
        success: function(data){
          if (data.success) {
            var response = data;
          }
        },
      error: function (error) {
          console.log('Error while trying to login customer '+JSON.stringify(error));
      }
      });
      
    });

    gokwikSdk.on("coupon-applied", function (response) {
      window.dataLayer.push({
        eventname: "coupon-applied",
      });
    });

    gokwikSdk.on("coupon-removed", function (response) {
      window.dataLayer.push({
        eventname: "coupon-removed",
      });
    });

    gokwikSdk.on("coupon-invalid", function (response) {
      window.dataLayer.push({
        eventname: "coupon-invalid",
      });
    });

    gokwikSdk.on("payment-method-selected", function (response) {
      var url = $(".paymentDataUrl").val();
      var merchant_payment_method = response.payment_method ? response.payment_method : response.methodType;
      var merchant_customerId = response?.cart?.customer_id ? response.cart.customer_id : '';
      var merchant_cartDiscounts = response?.cart?.discounts ? response.cart.discounts : '';
      var merchant_cartCurrency = response?.cart?.currency ? response.cart.currency : '';
      var merchant_cartItems = response?.cart?.items ? JSON.stringify(response.cart.items) : '';
      var merchant_total = response?.cart?.total ? response.cart.total : '';
      var merchant_totalTax = response?.cart?.total_tax ? response.cart.total_tax : '';
      var maerchant_shippingOptionsCharge = response?.cart?.shipping_options?.charge ? response.cart.shipping_options.charge : '';

      $.ajax({
        url: url,
        type: "POST",
        data: {
          merchant_payment_method: merchant_payment_method,
          merchant_customerId: merchant_customerId,
          merchant_cartDiscounts: merchant_cartDiscounts,
          merchant_cartCurrency: merchant_cartCurrency,
          merchant_cartItems: merchant_cartItems,
          merchant_total: merchant_total,
          merchant_totalTax: merchant_totalTax,
          maerchant_shippingOptionsCharge: maerchant_shippingOptionsCharge
        },
        success: function (res) {
          res.eventDataForGA.currentPage = window.location.href;
          res.eventDataForGA.event = 'add_payment_info';
          res.eventDataForGA.eventCategory = 'Checkout';
          res.eventDataForGA.eventAction = response.payment_method
          dataLayer.push(res.eventDataForGA);
        },
        error: function (err) {
          console.log("payment-method-selected | Error in Cart-PaymentEventData " + JSON.stringify(err));
        },
      });
    });

    gokwikSdk.on("payment-failure", function (response) {
      window.dataLayer.push({
        eventname: "payment-failure",
      });

      var form = $("<form></form>");
      var url = $(".failOrderUrl").val();
      form.attr("action", url);
      form.attr("method", "GET");

      var input1 = $("<input></input>")
        .attr("type", "hidden")
        .attr("name", "orderId")
        .attr("value", response.merchant_order_id);

      form.append(input1);

      $("body").append(form);
      form.submit();
    });

    gokwikSdk.on("order-complete", function (response) {
      window.dataLayer.push({
        eventname: "orderComplete",
        eventData: {
          merchant_order_id: response.merchant_order_id,
        },
      });

      var url = $(".changeStatusUrl").val();

      $.ajax({
        url: url,
        type: "post",
        dataType: "json",
        data: {
          orderId: response?.merchant_order_id ? response.merchant_order_id : '',
          token: response?.merchant_order_details?.token ? response.merchant_order_details.token : response.merchant_order_details.merchant_order_token
        },
        success: function (res) {
          var redirectUrl = $(".redirectUrlGokwik").val();
          var form = $("<form></form>");
          form.attr("action", redirectUrl);
          form.attr("method", "GET");

          var input1 = $("<input></input>")
            .attr("type", "hidden")
            .attr("name", "orderId")
            .attr("value", res.orderId);

          var input2 = $("<input></input>")
            .attr("type", "hidden")
            .attr("name", "token")
            .attr("value", res.token);

          form.append(input1);
          form.append(input2);

          $("body").append(form);
          form.submit();
        },
        error: function (err) {
          $.spinner().stop();
          alert("Technical issue: Please contact the support team.");
          window.location.reload();
        },
      });
    });

    gokwikSdk.on("checkout-close", function (response) {
      window.dataLayer.push({
      eventname: "checkoutClose",
      });

      if (response.type === 'merchant-payload' && response.data && response.data.merchantOrderId) {
      var form = $("<form></form>");
      var url = $(".failOrderUrl").val();
      form.attr("action", url);
      form.attr("method", "GET");
    
      var input1 = $("<input></input>")
        .attr("type", "hidden")
        .attr("name", "orderId")
        .attr("value", response.data.merchantOrderId);
    
      form.append(input1);
    
      $("body").append(form);
      form.submit();
      }else{
        window.location.reload();
      }
    });

    gokwikSdk.on("navigation_payment_options", function (response) {
      window.dataLayer.push({
        eventname: "navigationPaymentOptions",
      });
    });

    gokwikSdk.on("checkout-initiation-failure", function (response) {
      window.dataLayer.push({
        eventname: "checkout-initiation-failure",
      });
      var form = $("<form></form>");

      var url = $(".redirectFailureUrl").val();
      form.attr("action", url);
      form.attr("method", "GET");

      $("body").append(form);
      form.submit();
    });

    gokwikSdk.on("customer-attached", function (response) {
      window.dataLayer.push({
        eventname: "customer-attached",
      });
    });

    gokwikSdk.on("native-redirection", function (response) {
      window.dataLayer.push({
        eventname: "nativeRedirection",
      });
      var form = $("<form></form>");

      var url = $(".redirectFailureUrl").val();
      form.attr("action", url);
      form.attr("method", "GET");

      $("body").append(form);
      form.submit();
    });

  }
});
